package devxertech.com.pages.dashboard.softwareDevelopmentSection

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.browser.dom.observers.IntersectionObserver
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.backgroundPosition
import com.varabyte.kobweb.compose.ui.modifiers.backgroundSize
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H2

@Composable
fun SoftwareDevelopment(breakpoint: Breakpoint) {
    val sitePalette = ColorMode.current.toSitePalette()
    var yearsNumber by remember { mutableStateOf(1) }
    var clientsNumber by remember { mutableStateOf(1) }
    var projectsNumber by remember { mutableStateOf(1) }
    var expertsNumber by remember { mutableStateOf(1) }
    var isVisible by remember { mutableStateOf(false) }
    LaunchedEffect(Unit) {
        val targetElement = document.getElementById("experience-section")

        if (targetElement != null) {
            val observer = createIntersectionObserver {
                isVisible = true
            }
            observer.observe(targetElement)
        }
    }

    DisposableEffect(Unit) {
        val sectionElement = document.getElementById("experience-section")
        val observer = createIntersectionObserver { }

        sectionElement?.let {
            observer.observe(it)
        }

        onDispose {
            sectionElement?.let { observer.unobserve(it) }
        }
    }
    LaunchedEffect(isVisible) {
        if (isVisible) {
            launch {
                while (yearsNumber < 20) {
                    delay(250)
                    yearsNumber++
                }
            }
            launch {
                while (clientsNumber < 70) {
                    delay(60)
                    clientsNumber++
                }
            }
            launch {
                while (projectsNumber < 600) {
                    delay(3)
                    projectsNumber++
                }
            }
            launch {
                while (expertsNumber < 250) {
                    delay(10)
                    expertsNumber++
                }
            }
        }
    }

    Column (modifier = Modifier.fillMaxWidth()){
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(sitePalette.softwareSectionBackground.rgb),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
                .padding( top= 40.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                text = "Proven Approach ",
                modifier = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(18.px)
                    .color(sitePalette.commonSecondaryButtonColor.rgb)
                    .fontWeight(FontWeight.Medium)
                    .lineHeight(15.4.px)
                    .textTransform(TextTransform.Uppercase)
                    .padding(bottom = 10.px)
            )
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                val rowTextModifier = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
                    .fontWeight(FontWeight.ExtraBold)
                    .textTransform(TextTransform.Uppercase)
                H2(attrs = { style { property("display", "flex"); property("margin", "0") } }) { Row(
                    modifier = Modifier.flexWrap(FlexWrap.Wrap),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                    SpanText(
                        text = "Our ",
                        modifier = rowTextModifier.color(sitePalette.commonSecondaryButtonColor.rgb)
                    )
                    SpanText(
                        text = "Software ",
                        modifier = rowTextModifier.color(sitePalette.primary.rgb)
                    )
                    SpanText(
                        text = "Development ",
                        modifier = rowTextModifier.color(sitePalette.primary.rgb)
                    )

                        SpanText(
                            text = "Lifecycle",
                            modifier = rowTextModifier.color(sitePalette.commonSecondaryButtonColor.rgb)
                        )

                } }
//                if (breakpoint < Breakpoint.MD){
//                    SpanText(
//                        text = "Lifecycle",
//                        modifier = Modifier
//                            .fontFamily(Constants.FONT_FAMILY)
//                            .fontSize(18.px)
//                            .color(sitePalette.commonSecondaryButtonColor.rgb)
//                            .fontWeight(FontWeight.ExtraBold)
//                            .color(sitePalette.commonSecondaryButtonColor.rgb)
//                    )
//                }
            }
// Row for columns
            if(window.screen.width in 960..1439){
                Row(
                    modifier = Modifier
                        .fillMaxWidth().margin(leftRight = 30.px, top = 50.px)
                        .flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.SpaceEvenly,
                ) {
                    SoftwareColumn(breakpoint = breakpoint, image = Res.Image.understand_patterb,
                        number = "01", title = "Understand Pattern Identification",
                        description = "Devxer Methodology revolves around understanding pattern identification." +
                                "It involves analyzing data to identify and extract significant patterns.",
                        downArrow = true)
                    SoftwareColumn(breakpoint = breakpoint, image = Res.Image.wire_frame,
                        number = "02", title = "Wire Frame and Front end",
                        description = "After Pattern Identification, Our dedicated team creates" +
                                " wireframes and front-end designs that align with the identified patterns and user stories.",
                        downArrow = true
                    )
                }
                Row(
                    modifier = Modifier
                        .fillMaxWidth().margin(leftRight = 30.px, top = 10.px)
                        .flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.SpaceEvenly,
                ) {
                    SoftwareColumn(breakpoint = breakpoint, image = Res.Image.development_testing,
                        number = "03", title = "Development & Testing",
                        description = " Our development and testing process integrates different" +
                                " methodologies, allowing for continuous iteration and" +
                                " improvement at each stage to ensure quality and reliability before deployment"
                    )
                    SoftwareColumn(breakpoint = breakpoint, image = Res.Image.deployment,
                        number = "04", title = "Deployment",
                        description = " Devxer Technologies streamlined the deployment process by ensuring seamless integration across all" +
                                " platforms to minimize downtime and enhanced operational efficiency.",

                    )
                }

            }
            else{
                Row(
                    modifier = Modifier
                        .fillMaxWidth().margin(leftRight = 30.px, top = if (breakpoint == Breakpoint.MD) 60.px else 50.px)
                        .flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.Center,
                ) {
                    val imagelineModifier = Modifier
                        .width(120.px)
                        .border(1.px)
                        .margin(left = (-20).px, top = 50.px)

                    SoftwareColumn(breakpoint = breakpoint, image = Res.Image.understand_patterb,
                        number = "01", title = "Understand Pattern Identification",
                        description = "Devxer Methodology revolves around understanding pattern identification." +
                                "It involves analyzing data to identify and extract significant patterns.",
                        downArrow = breakpoint <=Breakpoint.LG,

                    )
                    if(breakpoint > Breakpoint.LG){
                        Image(src = Res.Image.development_arrow, modifier = imagelineModifier)
                    }
                    SoftwareColumn(breakpoint = breakpoint, image = Res.Image.wire_frame,
                        number = "02", title = "Wire Frame and Front end",
                        description = "After Pattern Identification, Our dedicated team creates" +
                                " wireframes and front-end designs that align with the identified patterns and user stories.",
                        downArrow = breakpoint <=Breakpoint.LG,
                        minusLeft = true
                    )
                    if (breakpoint > Breakpoint.LG){
                        Image(src = Res.Image.development_arrow, modifier = imagelineModifier)
                    }

                    SoftwareColumn(breakpoint = breakpoint, image = Res.Image.development_testing,
                        number = "03", title = "Development & Testing",
                        description = " Our development and testing process integrates different" +
                                " methodologies, allowing for continuous iteration and" +
                                " improvement at each stage to ensure quality and reliability before deployment",
                        downArrow = breakpoint <Breakpoint.MD,
                    minusLeft = true
                    )   
                    if (breakpoint > Breakpoint.LG){
                        Image(src = Res.Image.development_arrow, modifier = imagelineModifier)
                    }
                    SoftwareColumn(breakpoint = breakpoint, image = Res.Image.deployment,
                        number = "04", title = "Deployment",
                        description = " Devxer Technologies streamlined the deployment process by ensuring seamless integration across all" +
                                " platforms to minimize downtime and enhanced operational efficiency.",
                        minusLeft = true, lastMargin = true
                    )
                }
            }

            }
        }
        Column(
            modifier = Modifier.fillMaxWidth(if(breakpoint == Breakpoint.MD) 70.percent else if (breakpoint > Breakpoint.LG) 50.percent else 90.percent)
                .align(Alignment.CenterHorizontally),
            horizontalAlignment = Alignment.CenterHorizontally) {
            Box(
                modifier = Modifier.fillMaxWidth()
                    .height(if (breakpoint >= Breakpoint.LG) 170.px else 57.px)
                    .backgroundImage(url(Res.Image.software_bottom_sec))
                    .backgroundSize(BackgroundSize.Cover)
                    .backgroundPosition(BackgroundPosition.of(CSSPosition.Center)),
                contentAlignment = Alignment.Center
            )
            {
                Row(
                    modifier = Modifier
                        .id("experience-section")
                        .fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center
                ) {
                    SoftwareExperienceBox("$yearsNumber+", "Years Experience")
                    SoftwareExperienceBox("$clientsNumber+", "Satisfied Clients")
                    SoftwareExperienceBox("$projectsNumber+", "Finished Projects")
                    SoftwareExperienceBox("$expertsNumber+", "Skilled Experts")
                }
            }
        }

    }
}
@Composable
fun SoftwareColumn(breakpoint: Breakpoint,
                   image: String = "", number: String, title: String, description: String,
                   downArrow: Boolean = false,
                   minusLeft: Boolean = false, lastMargin: Boolean = false){
    val sitePalette = ColorMode.current.toSitePalette()

    Column(
        modifier =  Modifier
            .width(if(breakpoint < Breakpoint.XL)345.px else 300.px)
            .margin(
                top = if (breakpoint < Breakpoint.MD) 0.px else 30.px,
                bottom = when {
                    lastMargin -> 30.px
                    breakpoint >= Breakpoint.LG -> 30.px
                    else -> 0.px
                },
                left = when {
                    breakpoint < Breakpoint.MD -> 0.px
                    minusLeft -> (-30).px
                    else -> 0.px
                }
            )
        ,
//            .margin(top = if (window.screen.width < 768) 0.px else 30.px, bottom = if (window.screen.width < 768) 20.px else 30.px,
//                left = if(minusLeft) (-30).px else if (breakpoint < Breakpoint.MD || minusLeft) 0.px else 0.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Row (modifier = Modifier.margin(bottom = 30.px)){
            Image(src = image, modifier = Modifier
                .size(40.px)
                .border(1.px)
                .margin(right = (-20).px)
                .zIndex(2))
            SpanText(text = number, modifier = Modifier
                .fontFamily(Constants.ROBOTO_FONT)
                .fontSize(76.px)
                .color(sitePalette.commonSecondaryButtonColor.rgb)
                .fontWeight(FontWeight.Bold)
                .lineHeight(37.4.px))
        }
        SpanText(
            text = title,
            modifier = Modifier
                .fontFamily(Constants.FONT_FAMILY)
                .margin(top = if (breakpoint < Breakpoint.MD) 0.px else 10.px)
                .fontSize(15.px)
                .color(sitePalette.commonSecondaryButtonColor.rgb)
                .fontWeight(FontWeight.Bold)
                .lineHeight(37.4.px)
                .textAlign(TextAlign.Center)
        )
        SpanText(
            text = description,
            modifier = Modifier
                .fontFamily(Constants.FONT_FAMILY)
                .margin(top = if (breakpoint < Breakpoint.MD) 0.px else 10.px)
                .fontSize(12.px )
                .color(sitePalette.commonSecondaryButtonColor.rgb)
                .fontWeight(FontWeight.Normal)
                .lineHeight(20.px)
                .width(if (breakpoint >= Breakpoint.XL)250.px else if(window.screen.width in 1030..1252) 400.px else if(window.screen.width < 375) 270.px else 320.px)
                .textAlign(TextAlign.Center)
                .flexWrap(FlexWrap.Wrap)
        )
        if(downArrow){
            Image(src = Res.Image.developer_arrow_down, modifier = Modifier.margin(top = 20.px, bottom = 50.px))
        }
    }

}

@Composable
fun SoftwareExperienceBox(text: String,
                          description: String){
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()

    Box (modifier = Modifier.width(if(breakpoint >= Breakpoint.LG)140.px else if(window.screen.width < 375 ) 60.px else if (window.screen.width in 375..425) 75.px else 80.px)
        .height(if(breakpoint >= Breakpoint.LG)75.px else 38.px).border(1.px, LineStyle.Solid, sitePalette.bodyBackgroundSecondary.rgb)
        .margin(right = if(breakpoint >= Breakpoint.MD)20.px else 5.px),
        contentAlignment = Alignment.Center){
        Column(horizontalAlignment = Alignment.CenterHorizontally){
            SpanText(text, modifier = Modifier.fontFamily(Constants.FONT_FAMILY).fontSize(if(breakpoint >= Breakpoint.LG) FontSize.Medium else FontSize.XSmall)
                .color(sitePalette.bodyBackgroundSecondary.rgb))
            HorizontalDivider(modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb).width(20.px).margin(if (breakpoint >= Breakpoint.LG)10.px else 2.px).height(1.px))
            SpanText(description, modifier = Modifier.fontFamily(Constants.FONT_FAMILY)
                .fontSize(if(breakpoint >= Breakpoint.LG)11.px else if(window.screen.width < 375 )5.8.px else 6.px).color(sitePalette.primary.rgb))
        }
    }
}
fun createIntersectionObserver(callback: () -> Unit): IntersectionObserver {
    return IntersectionObserver { entries, _ ->
        for (entry in entries) {
            if (entry.isIntersecting) {
                callback()
            }
        }
    }
}
